import { AfterViewInit, Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { BooleanService } from 'src/app/core/services/utelize/general/boolean-service';
import { CommunicationDTO } from 'src/app/core/models/system/communication/communication.dto';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemParams, DgActionColumnWidth, DgColumnDataType, DgColumnWidths, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { firstValueFrom } from 'rxjs';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';

const apiPath             =environment.eSimApi+eSimApiPaths.Communications + "/" + eSimApiPaths.CommunicationsForSingleUser;
const exportFilenameSuffix="Communication-Data";
const popUpTitle          ="Communication";

@Component({
  selector: 'app-communications-embedded',
  templateUrl: './communications.component.html',
  styleUrls: ['./communications.component.scss'],
  providers: [GridViewService]
})

export class CommunicationsEmbeddedComponent implements AfterViewInit, OnChanges, OnInit {
  
  @Output() gridAddClick : EventEmitter<void>            =new EventEmitter<void>();
  @Output() gridEditClick: EventEmitter<CommunicationDTO>=new EventEmitter<CommunicationDTO>();
  
  @ViewChild('gridView', { static: false }) gridView!: GridViewComponent;
  
  private gridViewDefaults!: GridViewDefaults;
  
  public curUser        : SystemUserDTO;
  public dgApiPath!     : DgApiPath | undefined;
  public dgActionColumn!: DgActionColumn | undefined;
  public dgColumns!     : Array<DgColumn>;
  public dgPopup!       : DgPopup | undefined;
  public dgProperties!  : DgProperties | undefined;
  public gotDgProperties: boolean=false;
  
  constructor(
    private authenticationService     : AuthenticationService,
    private booleanService            : BooleanService,
    private componentAccessUserService: ComponentAccessUserService,
    private configSystemService       : ConfigSystemService,
    private encryptionService         : EncryptionService,
    private exceptionsService         : ExceptionsService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public async ngOnInit(): Promise<void> {
    try {
      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns();
      this.setUpDgPopup();
      this.setUpDgProperties();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private async setUpDgApiPaths(): Promise<void> {
    try {
      this.dgApiPath            =this.gridViewDefaults.setUpDgApiPaths(apiPath);
      this.dgApiPath!.delete    =environment.eSimApi+eSimApiPaths.Communications;
      this.dgApiPath!.refreshGet=() => this.setUpDgApiPathGet();

      await this.setUpDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async setUpDgApiPathGet(): Promise<void> {
    try {
      const encResult  =await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>this.curUser.userId, true));
      const userIdEncSS=encResult.result;

      this.dgApiPath!.get=apiPath + "?userIdEncSS=" + userIdEncSS;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn               =this.gridViewDefaults.setUpDgActionColumn();
      this.dgActionColumn!.allowDeleting=false;
      this.dgActionColumn!.width        =DgActionColumnWidth.oneButtonWithLeftRightPadding;
      this.dgActionColumn!.updateIcon   ="assets/images/_suresim/Button View 55x23.png";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgProperties() {
    try {
      this.dgProperties                 =this.gridViewDefaults.setUpDgProperties("", exportFilenameSuffix + "-" + this.curUser.userId);
      this.dgProperties!.addButtonHint  ="Compose Message";
      this.dgProperties!.encryptDeleteSS=true;
      this.dgProperties!.gridKey        ="EmbeddedCommunications";
      this.dgProperties!.pageSize       =20;
      this.dgProperties!.showAddButton  =true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns() {
    try {
      let dgColumn: DgColumn | undefined;
      
      //ID
      dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
      dgColumn!.gridVisible=this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
      dgColumn!.width      =DgColumnWidths.id;
      this.dgColumns       =[dgColumn!];

      //CompanyName
      // dgColumn=this.gridViewDefaults.setUpDgColumn("companyName", "Company", "", DgColumnDataType.string);
      // this.dgColumns.push(dgColumn!);

      //Username
      // dgColumn=this.gridViewDefaults.setUpDgColumn("username", "Username", "", DgColumnDataType.string);
      // this.dgColumns.push(dgColumn!);

      //Fullname
      // dgColumn=this.gridViewDefaults.setUpDgColumn("fullname", "Username", "", DgColumnDataType.string);
      // this.dgColumns.push(dgColumn!);

      //CommunicationType
      dgColumn=this.gridViewDefaults.setUpDgColumn("communicationType", "Communication Type", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //Subject
      dgColumn=this.gridViewDefaults.setUpDgColumn("subject", "Subject", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //Message
      dgColumn=this.gridViewDefaults.setUpDgColumn("message", "Message", "", DgColumnDataType.string);
      this.dgColumns.push(dgColumn!);

      //StartDate
      // dgColumn=this.gridViewDefaults.setUpDgColumn("startDate", "Start Date", "", DgColumnDataType.datetime);
      // this.dgColumns.push(dgColumn!);

      //EndDate
      // dgColumn=this.gridViewDefaults.setUpDgColumn("endDate", "End Date", "", DgColumnDataType.datetime);
      // this.dgColumns.push(dgColumn!);

      //Active
      // dgColumn            =this.gridViewDefaults.setUpDgColumn("active", "Active", true, DgColumnDataType.boolean);
      // dgColumn!.dataSource=this.booleanService.idAndDescriptionLookupDataSource();
      // this.dgColumns.push(dgColumn!);

      //EnteredByName
      dgColumn       =this.gridViewDefaults.setUpDgColumn("enteredByName", "From", "", DgColumnDataType.string);
      dgColumn!.width=DgColumnWidths.email;
      this.dgColumns.push(dgColumn!);

      //EnteredDate
      dgColumn       =this.gridViewDefaults.setUpDgColumn("enteredDate", "Entered Date", "", DgColumnDataType.datetime);
      dgColumn!.width=DgColumnWidths.dateWithTime;
      this.dgColumns.push(dgColumn!);

      //ReadMessage
      dgColumn            =this.gridViewDefaults.setUpDgColumn("readMessage", "Read", true, DgColumnDataType.boolean);
      dgColumn!.dataSource=this.booleanService.idAndDescriptionLookupDataSource();
      dgColumn!.width     =DgColumnWidths.active;
      this.dgColumns.push(dgColumn!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
    
  public gridAddButtonClick(e: any) {
    try {
      this.gridAddClick.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public gridEditButtonClick(e: any) {
    try {
      const maybeCommunication=e.row?.data;

      if (this.isCommunicationDTO(maybeCommunication)) {
        this.gridEditClick.emit(maybeCommunication as CommunicationDTO);

      } else {
        throw new Error("CommunicationsEmbeddedComponent - Invalid CommunicationDTO");
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private isCommunicationDTO(obj: any): obj is CommunicationDTO {
    try {
      return obj                                        &&
             typeof obj.communicationTypeID==="number"  &&
             typeof obj.message            ==="string"  &&
             typeof obj.subject            ==="string";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }
}
